import { makeIcon } from "components/ui/Icon";

export const ScreenShotIcon = makeIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      clipRule="evenodd"
      d="M11.3292 4.10557C11.668 3.428 12.3605 3 13.118 3H16.382C17.1395 3 17.832 3.428 18.1708 4.10557L19.118 6H20C21.1046 6 22 6.89543 22 8V14.5V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V14.5V8C2 6.89543 2.89543 6 4 6H5V5.5C5 4.67157 5.67157 4 6.5 4H7.5C8.32843 4 9 4.67157 9 5.5V6H10.382L11.3292 4.10557ZM4 15.5V20H20V15.5H15.7092C15.1159 16.9659 13.6787 18 12 18C10.3213 18 8.88415 16.9659 8.29076 15.5H4ZM8.03095 13.5C8.277 11.5268 9.96019 10 12 10C14.0398 10 15.723 11.5268 15.9691 13.5H20V8H4V13.5H8.03095ZM12.618 6H16.882L16.382 5H13.118L12.618 6ZM12 16.4C13.3255 16.4 14.4 15.3255 14.4 14C14.4 12.6745 13.3255 11.6 12 11.6C10.6745 11.6 9.6 12.6745 9.6 14C9.6 15.3255 10.6745 16.4 12 16.4Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>,
);
